import React from "react";

const Slide = ({
  className = "",
  slide,
  isLast,
  template,
  titleBgColor,
  titleTextColor,
  contentBgColor,
  contentTextColor,
  useCustomColors,
  scale = 1
}) => {
  const { slideType, headline, body, isEditing } = slide;
  const {
    container,
    inner,
    titleMain,
    titleSub,
    contentMain,
    contentBody,
    arrow,
    topLine,
    bottomLine,
  } = template.style;

  // choose picker colors based on slide type
  const bgColor   = slideType === 'title' ? titleBgColor : contentBgColor;
  const textColor = slideType === 'title' ? titleTextColor : contentTextColor;

  const commonContainerClasses = `
    ${container}
    ${isEditing ? "outline outline-2 outline-yellow-400" : ""}
  `;

  return (
    <div 
    className={`${className} ${commonContainerClasses}`}
    style={
      useCustomColors
        ? { backgroundColor: bgColor, color: textColor }
        : {}
    }
    >
      {/* top divider */}
      {topLine && (
        useCustomColors ? (
          <div
            className="absolute inset-x-14 top-14 h-px z-10"
            style={{ backgroundColor: textColor }}
          />
        ) : (
          <div className={`${topLine} z-10`} />
        )
      )}
      <div className={inner}>
        {slideType === "title" ? (
          <>
            <h1 className={titleMain}>{headline}</h1>
            <h2 className={titleSub}>{body}</h2>
          </>
        ) : (
          <>
            <h2 className={contentMain}>{headline}</h2>
            <p className={contentBody}>{body}</p>
          </>
        )}
      </div>

      {bottomLine && (
        useCustomColors ? (
          <div
            className="absolute inset-x-14 bottom-14 h-px z-10"
            style={{ backgroundColor: textColor }}
          />
        ) : (
          <div className={`${bottomLine} z-10`} />
        )
      )}
      {!isLast && <span className={arrow}>→</span>}
    </div>
  );
};

export default Slide;
